import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import InputLayout from "../../../../../../layout/InputLayout/InputLayout";
import TextToImageGuidanceSlider from "./Slider/TextToImageGuidanceSlider";

const TextToImageGuidance = () => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.textGuidanceScale" });

	return (
		<InputLayout label={t("label")} info={t("info")}>
			<TextToImageGuidanceSlider />
		</InputLayout>
	);
};

export default observer(TextToImageGuidance);
